module.exports = "/_next/static/images/beatgig-256-a2ce12989084a7604b2cb2994e29fccb.png";